import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { APP_INITIALIZER } from "@angular/core";
import { TraceService } from "@sentry/angular";
import { CompanyPartnerInterceptor } from "./company-partner-filter-interceptor.service";
import { ErrorInterceptorService } from "./error-interceptor.service";
import { JwtInterceptor } from "./jwt-interceptor.service";

export const INTERCEPTOR_PROVIDERS = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: ErrorInterceptorService,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: JwtInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: CompanyPartnerInterceptor,
    multi: true,
  },
  {
    provide: APP_INITIALIZER,
    useFactory: () => () => {},
    deps: [TraceService],
    multi: true,
  },
];
